// extracted by mini-css-extract-plugin
export default {"PasswordResetPhone":"yy_a bhs_qt bhs_a bhs_w bhs_ea bhs_tl"};